import { createContext, useContext, useEffect, useState } from 'react';
import { fetchStaticJson } from '../utils/utils';

const TextsContext = createContext({});

export const TextsProvider = ({ children }) => {
    const [texts, setTexts] = useState({});

    useEffect(() => {
        fetchStaticJson(window.config.translationFile)
            .then(setTexts)
            .catch(() => {
                // translations failed to load — app continues with empty texts
            });
    }, []);

    return <TextsContext.Provider value={texts}>{children}</TextsContext.Provider>;
};

export const useTexts = () => useContext(TextsContext);
